module.exports = __webpack_public_path__ + "assets/c036ecd2068087220363b417063432e7.png";